import { Button, Flex, Progress, ProgressProps } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import { useStore } from '../../stores/root-store';
import Subjects from '../../models/subjects';

const TicketCreateBar: React.FC<{subject: Subjects}> = ({subject}) => {

    const { subjectStores, authStore } = useStore();
    const ticketBar = subjectStores[subject].ticketBar;

    useEffect(() => {

        if (authStore.isAuthenticated) {
            ticketBar.loadCurrent();
        }
    }, [ticketBar, authStore.isAuthenticated]
    );

    const twoColors: ProgressProps['strokeColor'] = {
        '0%': '#00beff',
        '100%': '#c60bb7',
    };

    const onClick = () => {
        localStorage.setItem("place", "/math/tickets/add");
    };

    if (ticketBar.id) { 

        return (
            <Flex vertical title='Создание варианта'>
                <Flex align="center" style={{ padding: "5px 20px" }}>
                    <Progress percent={ticketBar.percent} strokeColor={twoColors} />
                    <Button type="link" href="/math/tickets/add" onClick={onClick}>Перейти к варианту</Button>
                </Flex>
            </Flex>
        );
    } else {
        return (<div style={{ paddingTop: "20px" }}/>);
    }
};

export default observer(TicketCreateBar);